import { useContext, useState } from "react";
import { Upload, message } from "antd";
import { UploadFileOutlined } from "@mui/icons-material";
import { EnrollmentContext } from "../../enrollment";
import { fraudDocumentUploader } from "../../api/api";
import { RenderUploadFooter } from "./textContent";
import { useTranslation } from "react-i18next";
const { Dragger } = Upload;

const messageStyles = {
  position: "absolute",
  width: "100%",
  top: "30px",
};

function DocUploadDropZone({
  fetchDocs,
  docFor,
  setCancelled,
  payDepositButton,
}: {
  fetchDocs: any;
  docFor: string;
  setCancelled?: any;
  payDepositButton?: any;
}) {
  const { t } = useTranslation("common");

  const [fileList, setFileList] = useState([]);
  const { enrollmentTokens } = useContext(EnrollmentContext) || {};
  // uploadCancelled state is when the prop setCancelled is not being passed
  // based on requirement in case of depositWaiver, we show a different screen when cancelled. that is when we pass the setCancelled prop.
  // in case the setCancelled is not passed, we are in the whitelist screen, we just append the renderUploadCancelledText to the upload footer.
  const [uploadCancelled, setUploadCancelled] = useState(false);

  // Update the fileList state variable when the files change
  const handleChange = (info: any) => {
    setFileList(info.fileList);
  };

  // function to handle the file submission
  const handleSubmit = async () => {
    // Add a conditional check before calling the forEach method
    // You can use the optional chaining operator (?.) or the logical AND operator (&&)
    try {
      if (!fileList.length) {
        message.error({
          content: t("uploadDocument"),
          style: messageStyles,
        });
        return;
      }
      const url = new URL(window.location.href);
      const idParam = url.searchParams.get("id");

      const signParam = url.searchParams.get("sign");
      const uploadResponse = await fraudDocumentUploader(
        fileList,
        idParam || enrollmentTokens[0]?.enrollment_id,
        signParam || enrollmentTokens[0]?.sign,
        docFor
      );

      if (uploadResponse?.status === 200) {
        setFileList([]);
        message.success({
          content: t("docUploadSuccess"),
          style: messageStyles,
        });
        await fetchDocs();
      } else {
        message.error({
          content: t("docUploadFailed"),
          style: messageStyles,
        });
      }
    } catch (err) {
      console.log("Data in err ==>", err);
    }
  };

  return (
    <div className="file-uploader">
      {!uploadCancelled && (
        <Dragger
          name="file"
          multiple={true}
          onChange={handleChange}
          style={{ padding: "20px", background: "white" }}
          fileList={fileList}
          beforeUpload={() => false}
        >
          <p className="ant-upload-drag-icon">
            <UploadFileOutlined />
          </p>
          <p className="ant-upload-text" style={{ color: "#254066" }}>
            {t("uploadFile")}
          </p>
          <p className="ant-upload-hint">{t("formatAllowed")}</p>
        </Dragger>
      )}
      {uploadCancelled ? (
        <div style={{ textAlign: "left" }}>
          {t("uploadCancelledText")}
          <br />
          <br />
          {t("uploadCancelledText2")}
        </div>
      ) : (
        <RenderUploadFooter
          setCancelled={setCancelled}
          setUploadCancelled={setUploadCancelled}
          handleSubmit={handleSubmit}
          payDepositButton={payDepositButton}
          t={t}
        />
      )}
    </div>
  );
}

export default DocUploadDropZone;
